import { render, staticRenderFns } from "./ManageSharedUsers.vue?vue&type=template&id=008b5fb6"
import script from "./ManageSharedUsers.vue?vue&type=script&lang=js"
export * from "./ManageSharedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports